module.exports = __webpack_public_path__ + "static/media/bmwe_logo_de.a824b2dd.svg";